import { render } from "./UploadDocumentosOrcamento.vue?vue&type=template&id=394e5610&scoped=true"
import script from "./UploadDocumentosOrcamento.vue?vue&type=script&lang=ts"
export * from "./UploadDocumentosOrcamento.vue?vue&type=script&lang=ts"

import "./UploadDocumentosOrcamento.vue?vue&type=style&index=0&id=394e5610&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-394e5610"

export default script